import {Divider, SuggestProps, UnstableCard as Paper} from '@logistics-frontend/blocks'
import {Image} from '@logistics-frontend/blocks/image'
import {useI18n} from '@logistics-frontend/core/i18n'
import {tag2url} from '@logistics-frontend/utils'
import React, {memo} from 'react'

import {AddressSuggest} from '../../../../../address-suggest/AddressSuggest'
import {suggestService} from '../../api'
import {InputControlled} from '../InputControlled'
import * as classes from './OrderDetails.classes'

type OrderDetailsProps = {
  isAddressSelected: boolean
  suggestProps?: Pick<SuggestProps, 'lead' | 'trail'>
  widgetId: string
}

export const OrderDetails = memo(
  ({isAddressSelected, suggestProps, widgetId}: OrderDetailsProps): React.ReactElement => {
    const {fetchAddressSuggest} = suggestService
    const i18n = useI18n()

    return (
      <Paper padding="S">
        <AddressSuggest
          className={classes.suggest}
          fetchSuggest={fetchAddressSuggest}
          label={
            isAddressSelected
              ? i18n('order.bdui.address.input.address')
              : i18n('order.bdui.address.input.address_choose')
          }
          location={[1, 1]}
          name={`${widgetId}.address`}
          pointType="a"
          renderPhoto={tag => <Image src={tag2url(tag)} />}
          size="l"
          variant="line"
          {...suggestProps}
        />
        <div className={classes.detailsWrapper}>
          <Divider />
          <div className={classes.inputsWrapper}>
            <InputControlled
              label={i18n('order.bdui.address.input.apartment')}
              name={`${widgetId}.apartment`}
              size="l"
              variant="line"
            />
            <InputControlled
              label={i18n('order.bdui.address.input.entrance')}
              name={`${widgetId}.entrance`}
              size="l"
              variant="line"
            />
            <InputControlled
              label={i18n('order.bdui.address.input.floor')}
              name={`${widgetId}.floor`}
              size="l"
              variant="line"
            />
            <InputControlled
              label={i18n('order.bdui.address.input.code')}
              name={`${widgetId}.code`}
              size="l"
              variant="line"
            />
          </div>
          <InputControlled
            label={i18n('order.bdui.address.input.comment')}
            name={`${widgetId}.comment`}
            size="l"
            variant="line"
          />
        </div>
      </Paper>
    )
  },
)
